export const mk_strings = {
  AtlantikTurs: 'Атлантик турс',
  home: "Дома",
  clients: "Клиенти",
  excursions: "Екскурзии",
  loggedInAs: "Најавен како: ",
  logout: "Одјави се",
  Skopje: 'Скопје',
  phoneFax: 'тел/факс',
  email: 'Е-маил',
  Kavadarci: 'Кавадарци',
  welcomeNote: "Добредојдовте на порталот на Атлантик Турс",
  slogan: "Алатки за управување на туристичката агенција, приспособени да ги поедностават вашите секојдневни операции и да ја подобрат продуктивноста.",
  whatWeDeliver: "Што испорачуваме!",
  efficientClientManagement: "Ефикасно управување со клиенти",
  efficientClientManagementSlogan: "Лесно ракувајте со профилите на клиентите, резервациите и комуникација.",
  comprehensiveAnalytics: "Сеопфатна аналитика",
  comprehensiveAnalyticsSlogan: "Детални извештаи за информирани одлуки.",
  taskAutomation: "Автоматизација на задачите",
  taskAutomationSlogan: "Автоматизирајте ги повторувачките задачи за да заштедите време и ресурси.",
  accessDenied: 'Забранет пристап...',
  notAllowed: 'Оваа страна не ви е достапна!',
  goBack: 'Врати се назад',
  search: 'Пребарај',
  name: 'Име',
  surname: 'Презиме',
  dateOfBirth: "Датум на раѓање",
  phoneNumber: "Тел. број",
  passportNumber: "Број на пасош",
  identityCard: "Лична карта",
  points: "Поени",
  loyaltyStatus: "Лојалност",
  address: "Адреса",
  ascending: 'Растечки',
  descending: 'Опаѓачки',
  sort: 'Сортирај',
  paginationSize: 'Број на редици: ',
  export: 'Експортирај',
  exportFailed: 'Неуспешен експорт',
  failedToExport: 'Не успеа да се експортира списокот со клиенти.',
  exportSuccessful: 'Успешен експорт',
  addNewClient: 'Додај нов клиент',
  actions: 'Промени',
  noClients: 'Нема клиенти',
  previous: 'Претходна',
  next: 'Следна',
  excursionHistory: "Историја на екскурзии",
  loadingExcursions: 'Вчитување на ексурзии...',
  details: 'Детали',
  excursionName: "Име на екскурзија",
  excursionPrice: "Цена на екскурзија",
  excursionDiscount: "Попуст на екскурзија",
  additionalDiscount: "Дополнителен попуст",
  pointsUsed: "Искористени поени",
  pointsGained: "Добиени поени",
  extraExpenses: 'Дополнителни трошоци',
  finalPrice: "Финална цена",
  paidPrice: "Платена сума",
  submit: "Поднеси",
  cancel: 'Откажи',
  page: 'страна',
  of: 'од',
  clientDeletedSuccessfully: "Успешно избришан клиент",
  somethingWentWrong: 'Не е како што треба',
  confirmationDelete: 'Дали навистина сакаш да го избришеш ова?',
  addClient: 'Додај клиент',
  updateClient: 'Ажурирај клиент',
  successfullyAddedClient: 'Успешно додаден клиент!',
  successfullyUpdatedClient: 'Успешно ажуриран клиент!',
  clientDetails: "Детали за клиентот",
  missingEorC: 'Недостаува екскурзија или клиент!',
  successfullyAddedExcursion: 'Успешно додадена екскурзија!',
  successfullyUpdatedExcursion: 'Успешно ажурирана екскурзија!',
  excursionDeletedSuccessfully: 'Успешно избришана екскурзија!',
  addNewExcursion: "Додади нова екскурзија",
  selectExcursion: "Избери екскурзија",
  updateExcursion: 'Ажурирај екскурзија',
  addExcursion: 'Додај екскурзија',
  excursion: 'Екскурзија',
  discount: "Попуст",
  travelingDocument: "Патен документ",
  startingPoint: "Почетно место",
  usePoints: "Искористи поени",
  note: "Забелешка",
  confirmedReservation: "Потврдена резервација",
  totalPrice: "Вкупна цена",
  requiredField: 'Полето е задолжително',
  signIn: "Најава",
  projectName: "Име на проект",
  payments: "Плаќања",
  successfullyUpdatedPayment: 'Успешно ажурирано плаќање!',
  paymentDeletedSuccessfully: "Успешно избришано плаќање!",
  successfullyAddedPayment: 'Успешно додадено плаќање!',
  excursionId: "ИД на екскурзија",
  placeTo: "Место до",
  dateFrom: "Датум од",
  dateTo: "Датум до",
  price: "Цена",
  totalSeats: "Вкупно места",
  bookedSeats: "Пополнети места",
  clientName: "Име на клиент",
  clientSurname: "Презиме на клиент",
  addPayment: 'Додај плаќање',
  paymentDate: 'Датум на плаќање',
  amount: 'Износ',
  selectDate: 'Избери датум',
  enterAmount: 'Внеси износ',
  paymentHistory: 'Историјат на плаќање',
  deletedSuccessfully: 'Успешно избришано',
  travelList: 'Патна листа за екскурзијата: ',
  noDetailsForExcursion: 'Нема детали за оваа екскурзија',
  noExcursions: 'Нема екскурзии!',
  noExcursionsForClient: 'Нема екскурзии за овој клиент!',
  noPaymentHistory: 'Нема историја на плаќања!',
  successfullyUpdatedDetails: 'Успешно ажурирани детали!',
  noData: 'Нема податоци',
  seatNumber: 'Број на седиште',
  employees: 'Вработени',
  addEmployee: 'Додади вработен',
  editEmployee: 'Промени вработен',
  username: 'Корисничко име',
  role: 'Улога',
  password: 'Лозинка',
  employeeDeletedSuccessfully: "Успешно избришан вработен",
  passwordChange: 'Промени лозинка',
  currentPassword: 'Постоечка лозинка',
  newPassword: 'Нова лозинка',
  confirmPassword: 'Потврдена лозинка',
  login: 'Најава',
  loginMessage: "Ве молиме најавете се",
  backToMainPage: 'Вратете се на почетната страна',
  loggingIn: 'Се најавува...',
  loginFailed: 'Неуспешна најава. Проверете ги податоците.',
  employeeAddedSuccessfully: 'Успешно додаден вработен',
  employeeUpdatedSuccessfully: 'Успешно ажуриран вработен',
  error: 'Грешка',
  fullExport: 'Целосен експорт',
  uniqueMessage: 'Корисничкото име и е-маилот мора да се уникатни'
};